import script from "./CreateTagPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateTagPopup.vue?vue&type=script&setup=true&lang=js"

import "./CreateTagPopup.vue?vue&type=style&index=0&id=6c5705d3&lang=css"

const __exports__ = script;

export default __exports__